module.exports = __webpack_public_path__ + "assets/199ef3c7d14829663d68d1bb79d1cc6f.mp3";